import { I18nPluralPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { CustomFacet, RangeFacet } from '@catalog/const';
import { ProductSearchPage, StringTemplate, TranslationService } from '@spartacus/core';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { ProductListService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class BaseProductListPageMetaResolver {
  private searchResults$: Observable<ProductSearchPage> = this.productListService
    .getResults()
    .pipe(filter((page) => page && Object.keys(page).length > 0));

  private totalResults$: Observable<number> = this.searchResults$.pipe(
    map((page: ProductSearchPage) => page.pagination?.totalResults || 0),
  );

  private productsCount$: Observable<string> = this.totalResults$.pipe(
    switchMap((count: number) => this.translation.translate('customProductDetails.subTitle', { count })),
  );

  private minPrice$: Observable<number> = this.searchResults$.pipe(
    map((page: ProductSearchPage) => page.facets as CustomFacet[]),
    map((facets: CustomFacet[]) => facets?.find((f) => f.code === 'personalPrice') as RangeFacet),
    map((facet: RangeFacet | undefined) => facet?.minValue || 0),
  );

  constructor(
    private i18n: I18nPluralPipe,
    private translation: TranslationService,
    private productListService: ProductListService,
  ) {}

  getSearchResults(): Observable<ProductSearchPage> {
    return this.searchResults$;
  }

  getSubTitle(): Observable<string> {
    return this.productsCount$.pipe(map((res) => `${res}`));
  }

  getSearchPageSubTitle(): Observable<string> {
    return this.totalResults$.pipe(
      switchMap((count: number) => {
        const translation = this.translation.translate('customProductDetails.subTitle', { count });

        return translation.pipe(map((res) => ({ count, res })));
      }),
      map(({ count, res }) => {
        return `  ${this.i18n.transform(count, { one: 'найден', few: 'найдено', many: 'найдено' })}  ${res} `;
      }),
    );
  }

  processSeoTemplate(template: string): Observable<string> {
    return combineLatest({
      totalResults: this.productsCount$,
      minPrice: this.minPrice$,
    }).pipe(
      map((params) => {
        return template ? StringTemplate.resolve(template, params) : '';
      }),
    );
  }
}
